import { Injectable } from '@angular/core'
import {
  UnespCoreMenuItem,
  UnespCoreMenuNavigationService,
  UnespCoreMessageService,
  UnespCoreUserService,
} from '@unesp/core'
import { BehaviorSubject } from 'rxjs'
import { Perfil } from './perfil'
import { menuPropg } from 'src/app/menus/menu-propg'
import { menuStpg } from 'src/app/menus/menu-stpg'
import { menu } from 'src/app/menus/menu'
import { menuCandidato } from 'src/app/menus/menu-candidato'
import { LocalStorageService } from 'src/app/shared/services/local-storage.service'
import { getPerfilByKey } from 'src/app/shared/enums/perfil.enum'
import { UsuarioLogin } from './usuario-login'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  nomeUsuario: string = ''
  campus: string = ''
  perfis: Perfil[] = []
  isDiscente$ = new BehaviorSubject<boolean>(false)
  perfis$ = new BehaviorSubject<Perfil[]>([])

  constructor(
    private unespCoreUserService: UnespCoreUserService,
    private unespCoreMenuNavigationService: UnespCoreMenuNavigationService,
    private localStorageService: LocalStorageService,
    private unespCoreMessageService: UnespCoreMessageService
  ) {
    // Obtem o perfil em cache (caso exista)
    let perfilEmCache = this.localStorageService.get('perfil')
    // Obtem o usuário logado
    this.unespCoreUserService.user$.subscribe(userLogin => {
      if (userLogin) {
        if ((userLogin as UsuarioLogin).campus) {
          this.campus = (userLogin as UsuarioLogin).campus
        }
        // Se ainda não existe pega o último perfil da lista
        if (perfilEmCache) {
          const found: string[] | undefined = userLogin?.roles.filter(role => role === perfilEmCache)
          if (!found || !found.length) {
            this.localStorageService.remove('perfil')
            perfilEmCache = userLogin?.roles.filter(role => role !== '**' && role !== '!!').pop()
          }
        } else {
          perfilEmCache = userLogin?.roles.filter(role => role !== '**' && role !== '!!').pop()
        }
        this.nomeUsuario = userLogin?.nomeUsuario ?? ''
        this.perfis = []
        userLogin.roles.forEach(role => {
          if (role !== '**' && role !== '!!') {
            this.perfis.push({
              nome: role,
              selecionado: perfilEmCache === role,
            })
          }
        })
        // Envia os perfis do usuário logado
        this.perfis$.next(this.perfis)
        // Carrega o menu de acordo com o perfil
        this.loadMenuPorPerfilNome(perfilEmCache)
      }
    })
  }

  getNomeUsuario(): string {
    return this.nomeUsuario
  }

  loadMenuPorPerfil(perfil: Perfil) {
    this.loadMenuPorPerfilNome(perfil.nome)
  }

  setItensMenuSource(itens: UnespCoreMenuItem[]) {
    this.unespCoreMenuNavigationService.itensMenuSource.next(itens)
  }

  loadMenuPorPerfilNome(nome: string) {
    // Perfil previamente selecionado
    const perfilPreviamenteSelecionado = this.perfis.filter(p => p.selecionado)
    // Salva valores em cache
    this.savePefilOnCache(nome)
    // Marca qual perfil foi selecionado
    this.perfis.forEach(perfil => {
      perfil.selecionado = perfil.nome === nome
    })
    // Define o menu e se é discente
    switch (nome) {
      case 'ALUNO_REGULAR':
        this.isDiscente$.next(true)
        //o menu é recarregado de acordo com o ra selecionado no registro-academico-selecionar
        break
      case 'ALUNO_ESPECIAL':
        this.isDiscente$.next(true)
        //o menu é recarregado de acordo com o ra selecionado no registro-academico-selecionar
        break
      case 'STPG':
        this.unespCoreMenuNavigationService.itensMenuSource.next(menuStpg)
        this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
        this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
        break
      // case 'AREX':
      //   this.unespCoreMenuNavigationService.itensMenuSource.next(menuArex)
      //   this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
      //   this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
      //   break
      case 'CANDIDATO':
        this.unespCoreMenuNavigationService.itensMenuSource.next(menuCandidato)
        this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
        break
      // case 'CCD':
      //   this.unespCoreMenuNavigationService.itensMenuSource.next(menuCcd)
      //   this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
      //   this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
      //   break
      // case 'CONSULTA_DISCENTE':
      //   this.unespCoreMenuNavigationService.itensMenuSource.next(menuConsultaDiscente)
      //   this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
      //   this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
      //   break
      // case 'DTA':
      //   this.unespCoreMenuNavigationService.itensMenuSource.next(menuDta)
      //   this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
      //   this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
      //   break
      case 'PROPG':
        this.unespCoreMenuNavigationService.itensMenuSource.next(menuPropg)
        this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
        this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
        break
      // case 'DOCENTE':
      //   this.unespCoreMenuNavigationService.itensMenuSource.next(menuDocente)
      //   this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
      //   this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
      //   break
      default:
        this.unespCoreMenuNavigationService.itensMenuSource.next(menu)
        this.setDiscenteFalseAndRemoveIdAssAndSetIdentificacao()
        this.notifyUserProfileChanged(perfilPreviamenteSelecionado, nome)
    }
  }

  savePefilOnCache(nome: string): void {
    this.localStorageService.set('perfil', nome)
  }

  setDiscenteFalseAndRemoveIdAssAndSetIdentificacao() {
    this.isDiscente$.next(false)
    this.localStorageService.remove('idAss')
    this.localStorageService.set('identificacaoUsuario', {
      nome: this.nomeUsuario,
      campus: this.campus,
    })
  }

  notifyUserProfileChanged(perfilPreviamenteSelecionado: Perfil[], nome: string) {
    if (perfilPreviamenteSelecionado.length === 0 || perfilPreviamenteSelecionado[0].nome !== nome) {
      this.unespCoreMessageService.showMessageSuccess('Perfil ' + getPerfilByKey(nome) + ' selecionado.')
    }
  }
}
